import { updateConfig } from '@cometchat/calls-sdk-core';
import { useEffect, useState } from 'react';
import { CometChatCalls } from '../../sdk';
import CallScreen from '../../ui/CallScreen.web';
import { DevOverlay } from '../../ui/dev/DevOverlay';
import classes from './app.module.css';

// const callAppSettings = new CometChatCalls.CallAppSettingsBuilder()
//   .setAppId('26580020f03ff346')
//   .setRegion('IN')
//   // .setHost('https://calls-in.cometchat.io')
//   .build();

// const callSettings = new CometChatCalls.CallSettingsBuilder()
//   .enableDefaultLayout(true)
//   .setIsAudioOnlyCall(false)
//   .showEndCallButton(true)
//   .showMuteAudioButton(true)
//   .showPauseVideoButton(true)
//   .showScreenShareButton(true)
//   .showModeButton(true)
//   .startWithAudioMuted(false)
//   .startWithVideoMuted(false)
//   .showRecordingButton(false)
//   .startRecordingOnCallStart(false)
//   .showSwitchToVideoCallButton(true)
//   .showVirtualBackgroundSetting(true)
//   .setIdleTimeoutPeriod(300)
//   .setMode('TILE')
//   // .setMainVideoContainerSetting(videoSettings)
//   .setLocalizedStringObject({
//     STOP_SCREEN_SHARE_TEXT: 'Stopped Sharing',
//     USER_LEFT_CALL_MSG: 'User has gone',
//     APPLY: 'Laga do',
//     CHOOSE_BACKGROUND: 'Background choose karo',
//   })
//   // .setMainVideoContainerSetting({
//   //   nameLabel: {
//   //     position: "top-left",
//   //     visible: false,
//   //     color: "rgba(27, 27, 27, 0.4)",
//   //   },
//   // } as any)
//   .setCallListener(
//     new CometChatCalls.OngoingCallListener({
//       onUserListUpdated: userList => {
//         console.log('user list:', userList);
//       },
//       onCallEndButtonPressed: () => {
//         setIsStarted(false);
//         console.log('LOGLOG 2025-08-20, call end button pressed');
//         setTimeout(() => {
//           const htmlNode = document.getElementById('call-screen');
//           if (htmlNode) {
//             htmlNode.style.display = 'none';
//           }
//           // document.getElementById("call-screen")!.innerHTML = "";
//         }, 200);
//       },
//       onCallEnded: () => {
//         console.log('LOGLOG 2025-08-20 Call ended');
//         // CometChatCalls.endSession(); // This
//         // CometChat.endCall();
//       },
//       onError: error => {
//         console.log('Error :', error);
//       },
//       onMediaDeviceListUpdated: deviceList => {
//         console.log('Device List:', deviceList);
//       },
//       onUserMuted: event => {
//         // This event will work in JS SDK v3.0.2-beta1 & later.
//         console.log('Listener => onUserMuted:', {
//           userMuted: event.muted,
//           userMutedBy: event.mutedBy,
//         });
//       },
//       onScreenShareStarted: () => {
//         // This event will work in JS SDK v3.0.3 & later.
//         console.log('Screen sharing started.');
//       },
//       onScreenShareStopped: () => {
//         // This event will work in JS SDK v3.0.3 & later.
//         console.log('Screen sharing stopped.');
//       },
//       onCallSwitchedToVideo: event => {
//         // This event will work in JS SDK v3.0.8 & later.
//         console.log('call switched to video:', {
//           sessionId: event.sessionId,
//           callSwitchInitiatedBy: event.initiator,
//           callSwitchAcceptedBy: event.responder,
//         });
//       },
//       onRecordingStarted: e => {
//         console.log('Recording started', e);
//       },
//       onRecordingStopped: () => {
//         console.log('Recording stopped');
//       },
//       onUserJoined: user => console.log('event => onUserJoined', user),
//       onUserLeft: user => console.log('event => onUserLeft', user),
//     }),
//   )
//   .build();

function getSearchParam(key: string, fallback: string) {
  return new URLSearchParams(window.location.search).get(key) ?? fallback;
}

function setSearchParam(key: string, value: string) {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);
  window.history.replaceState(null, '', `?${params.toString()}`);
}

function SampleAppSDK() {
  const [isStarted, setIsStarted] = useState(false);
  const [sessionId, setSessionId] = useState(() =>
    getSearchParam('sessionId', 's001'),
  );
  const [displayName, setDisplayName] = useState(() =>
    getSearchParam('displayName', ''),
  );

  useEffect(() => {
    // CometChatCalls.init({
    //   appId: '281468e1dc60990c',
    //   region: 'IN',
    //   authKey: '23bf9e9d4fad7deedf4325ed05ecc792450546dd',
    // });
    // CometChatCalls.init({
    //   appId: '254240e2836ab209',
    //   region: 'US',
    //   authKey: 'a48fa6edf9e1f55e2a1fd59e80e182bf41730a9d',
    // });
    // CometChatCalls.init({
    //   appId: '253778b716dc6335',
    //   region: 'US',
    //   authKey: 'eb66838530e31d1e5f68657faf9d4bc31b0cc354',
    //   host: 'https://253778b716dc6335.call-us.cometchat-staging.com/v3.0',
    //   adminHost: 'https://253778b716dc6335.api-us.cometchat-staging.com/v3.0',
    //   clientHost:
    //     'https://253778b716dc6335.apiclient-us.cometchat-staging.com/v3.0',
    // });
    CometChatCalls.init({
      appId: '278538a17a6a73bf',
      region: 'IN',
      authKey: '1b6c71f629c522df1142285087f6c5db188c8188',
    });
    // CometChatCalls.init({
    //   appId: '2547167fe69871fd',
    //   region: 'US',
    //   authKey: '5e1fc8edd290a2f194a6634178eb9db2895391ad',
    //   adminHost: 'https://2547167fe69871fd.api-us.cometchat-staging.com/v3.0',
    //   clientHost:
    //     'https://2547167fe69871fd.apiclient-us.cometchat-staging.com/v3.0',
    //   host: 'https://2547167fe69871fd.call-us.cometchat-staging.com/v3.0',
    // });
    // CometChatCalls.init({
    //   appId: '26580020f03ff346',
    //   region: 'IN',
    //   authKey: '4152b0366478871f0fa8d19a287dd6f5ed5f8eff',
    // });
    // CometChatCalls.init(callAppSettings);
  }, []);

  useEffect(() => {
    return CometChatCalls.addEventListener('onConnectionClosed', () => {
      setIsStarted(false);
    });
  }, []);

  return (
    <>
      {!isStarted ? (
        <div className={classes.container}>
          <div className={classes.card}>
            <input
              className={classes.input}
              type="text"
              placeholder="Session ID"
              value={sessionId}
              onChange={e => {
                setSessionId(e.target.value);
                setSearchParam('sessionId', e.target.value);
              }}
            />
            <input
              className={classes.input}
              type="text"
              placeholder="Your Name"
              value={displayName}
              onChange={e => {
                setDisplayName(e.target.value);
                setSearchParam('displayName', e.target.value);
              }}
            />
            <button
              className={classes.button}
              onClick={() => {
                const uid =
                  new URLSearchParams(window.location.search).get('uid') ??
                  'cometchat-uid-1';
                CometChatCalls.login(uid).then(user => {
                  console.log('Login Successful:', { user });
                  CometChatCalls.generateToken(sessionId).then(token => {
                    console.log('Token generated', token);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (CometChatCalls as any)
                      .callVerifyTokenAPI(token.token)
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      .then((res: any) => {
                        console.log('Token verified', res.data);
                        updateConfig({
                          sessionId: sessionId,
                          displayName: displayName,
                          hideRecordingButton: false,
                          hideChatButton: false,
                          hideShareInviteButton: false,
                          internalSettings: JSON.stringify(res),
                        });
                        setIsStarted(true);
                      });
                  });
                });
              }}>
              Start Session
            </button>
          </div>
        </div>
      ) : (
        <div
          style={{
            height: '100vh',
            width: '100vw',
            backgroundColor: 'red',
          }}>
          <CallScreen />
        </div>
      )}
      <DevOverlay />
    </>
  );
}

export default SampleAppSDK;
